import Layout from 'layouts/Default'
import {
  Box,
  Button,
  CircularProgress,
  DialogProps,
  Grid,
  IconButton,
  Step,
  StepButton,
  Stepper,
  Typography,
} from '@mui/material'
import Breadcrumbs from 'components/Breadcrumbs'
import Label from 'components/Label'
import { StyledBoxContainerTitle as ContainerTitle } from 'pages/SearchTeenager/styles'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import client from 'services/client'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { HttpErrorType } from 'types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'
import { useBackdrop } from 'contexts/backdrop.context'
import { useSnackBar } from 'contexts/snackbar.context'
import DialogTitle from '@mui/material/DialogTitle'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import { DataGridCustom } from 'pages/CreateCreas/components/TableData/style'
import { useMeioAbertoHistorico } from 'hooks/meio-aberto-historico.hook'
import { GridColDef } from '@mui/x-data-grid'
import dayjs from 'dayjs'
import DownloadIcon from '@mui/icons-material/Download'
import { SocioeducationMeasureReport } from 'pages/SocioeducationMeasureEdit/GenerateReport'
import { useReactToPrint } from 'react-to-print'
import { SocioeducationHistoryType } from 'types/socioeducation-history.type'
import { useMeioAberto } from 'hooks/meio-aberto.hook'
import { useAuthContext } from '../../contexts/auth.context'
import { Funcionalidades } from 'utils/helpers/funcionalidades'

const stepRoutes = [
  { label: 'Identificação', path: 'identificacao' },
  { label: 'Dados Familiares', path: 'dados-familiares' },
  { label: 'Dados Processuais', path: 'dados-processuais' },
  { label: 'Medidas Aplicadas', path: 'medidas-aplicadas' },
  { label: 'Acompanhamento', path: 'acompanhamento' },
]

export const SocioeducationMeasureEditPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()
  const { handleHasPermission } = useAuthContext()

  const { showSnackBar } = useSnackBar()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const { meioAberto, handleBuscarPorId } = useMeioAberto(id)

  const [pessoaFisicaId, setPessoaFisicaId] = useState<number | null | undefined>(null)

  const formRefs = useRef({})

  const currentStep = stepRoutes.findIndex(
    (step) => location.pathname === `/meio-aberto/${id}/${step.path}`,
  )

  const handleNavigation = async (targetStep: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (formRefs.current[currentStep]) {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await handleSubmit()
        navigate(`/meio-aberto/${id}/${targetStep}`)
      } catch (error) {
        console.log('error', error)
      }
    } else {
      navigate(`/meio-aberto/${id}/${targetStep}`)
    }
  }

  const handleSubmit = async () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (formRefs.current[currentStep]) {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await formRefs.current[currentStep].submit() // Submete o formulário do step atual
      } catch (error) {
        console.log('error', error)
      }

      await handleBuscarPorId()
    }
  }

  const handleNext = () => {
    const nextStep = stepRoutes[currentStep + 1]?.path
    if (nextStep) {
      handleNavigation(nextStep)
    }
  }

  const handleBack = () => {
    if (currentStep !== 0) {
      const prevStep = stepRoutes[currentStep - 1]?.path
      if (prevStep) {
        handleNavigation(prevStep)
      }
    } else {
      if (pessoaFisicaId) {
        navigate(`/ficha-adolescente/${pessoaFisicaId}`)
      }
    }
  }

  const handleStepClick = (stepIndex: number) => {
    const targetPath = stepRoutes[stepIndex].path
    handleNavigation(targetPath)
  }

  const handleGenerateReport = async () => {
    const url = `/meio-aberto/${id}/historico`

    handleBackdropOpen()
    await client
      .post(url)
      .then(async () => {
        showSnackBar(SystemMessages.MESSAGE_001, 'success')
      })
      .catch((error: HttpErrorType) => showSnackBar(errorMessage(error), errorColor(error)))
      .finally(async () => {
        handleBackdropClose()
        await handleBuscarPorId()
      })
  }

  return (
    <Layout>
      <Grid container item xs={12} sx={{ mb: 2 }}>
        <Breadcrumbs>
          <Label text='Meio Aberto' v='body1' />
          <Label text={stepRoutes[currentStep].label} bold v='body1' />
        </Breadcrumbs>
      </Grid>

      <Grid container direction='column' spacing={4}>
        <Grid item xs={12}>
          <ContainerTitle>
            <Label
              text='FORMULÁRIO PARA ELABORAÇÃO DO PLANO INDIVIDUAL DE ATENDIMENTO - PIA'
              v='h6'
              bold
            />
            {meioAberto?.exibeHistorico && <HistoryModal />}
          </ContainerTitle>
        </Grid>
        <Grid item xs={12}>
          <Stepper activeStep={currentStep} nonLinear alternativeLabel>
            {stepRoutes.map((step, index) => (
              <Step key={step.label}>
                <StepButton onClick={() => handleStepClick(index)}>{step.label}</StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid item xs={12}>
          <Outlet context={{ currentStep, formRefs, setPessoaFisicaId }} />
        </Grid>
        <Grid item xs={12}>
          <Box display={'flex'} flexDirection={'row'} gap={2} justifyContent={'center'}>
            <Button variant={'outlined'} color={'secondary'} onClick={handleBack}>
              Voltar
            </Button>
            {handleHasPermission(Funcionalidades.meioAberto.editar) && (
              <Button variant={'contained'} color={'info'} onClick={handleSubmit}>
                Salvar Rascunho
              </Button>
            )}
            {currentStep < 4 && (
              <Button variant={'contained'} color={'secondary'} onClick={handleNext}>
                Avançar
              </Button>
            )}
            {(meioAberto?.status === 'ALTERADO' ||
              ((meioAberto?.status === null || meioAberto?.status === 'RASCUNHO') &&
                currentStep === 4)) &&
              handleHasPermission(Funcionalidades.meioAberto.relatorio.gerar) && (
                <Button variant='outlined' color='info' onClick={handleGenerateReport}>
                  Gerar Relatório
                </Button>
              )}
          </Box>
        </Grid>
      </Grid>
    </Layout>
  )
}

const HistoryModal = () => {
  const { id } = useParams()
  const [fullWidth] = useState(true)
  const [maxWidth] = useState<DialogProps['maxWidth']>('md')

  const [open, setOpen] = useState<boolean>(false)

  const {
    historico,
    isLoading,
    handleBuscar,
    page,
    totalOfElements,
    handleNewPage,
    rowsPerPage,
    rowsOptions,
    handleRowsPerPage,
  } = useMeioAbertoHistorico(id)

  useEffect(() => {
    ;(async () => {
      if (open) {
        await handleBuscar()
      }
    })()
  }, [open])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const getNameFile = (date?: string | null) => {
    if (!date) return ''
    return `PIA-${dayjs(date).format('DD-MM-YYYY_HH-mm')}`
  }

  const columns: GridColDef[] = [
    {
      field: 'Nome',
      headerName: 'Nome',
      flex: 1,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => params.row.dataRelatorio && getNameFile(params.row.dataRelatorio),
    },
    {
      field: 'dataRelatorio',
      headerName: 'Data de Modificação',
      flex: 1,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => params.value && dayjs(params.value).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      field: 'action',
      headerName: '',
      width: 100,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => <ActionComponent data={params.row} />,
    },
  ]

  const ActionComponent = ({ data }: { data?: SocioeducationHistoryType }) => {
    const pageTitle = getNameFile(data?.dataRelatorio) || ''

    const componentRef = useRef(null)

    const handlePrint = useReactToPrint({
      content: () => componentRef?.current,
      documentTitle: pageTitle,
    })

    return (
      <Fragment>
        <IconButton color='info' aria-label='download' onClick={handlePrint}>
          <DownloadIcon fontSize='small' />
        </IconButton>
        <Box visibility={'hidden'}>
          <SocioeducationMeasureReport
            componentRef={componentRef}
            medidasAplicadas={data?.medidaAplicada}
            identificacao={data?.identificacao}
            dadosFamiliares={data?.dadosFamiliares}
            dadosAcompanhamento={data?.acompanhamento}
            dadosProcessuais={data?.dadosProcessuais}
          />
        </Box>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Button variant={'contained'} color={'info'} onClick={handleOpen}>
        Histórico
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
        <DialogTitle>
          <Typography variant={'h6'} color={'primary.main'}>
            Histórico
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {historico ? (
            <DataGridCustom
              rows={historico}
              columns={columns}
              autoHeight
              localeText={{
                footerRowSelected: (numero) =>
                  numero > 1 ? `${numero} selecionados` : `${numero} selecionado.`,
              }}
              pageSizeOptions={rowsOptions}
              rowCount={totalOfElements}
              loading={isLoading}
              componentsProps={{
                pagination: {
                  labelRowsPerPage: 'Linhas por página:',
                  labelDisplayedRows: ({ from, to, count }) =>
                    `Linhas ${from}-${to} de um total de ${count} itens.`,
                  onRowsPerPageChange: handleRowsPerPage,
                },
              }}
              onPaginationModelChange={({ page }) => {
                handleNewPage(null, page)
              }}
              paginationModel={{
                page: page,
                pageSize: rowsPerPage,
              }}
            />
          ) : (
            <Box display={'flex'} justifyContent={'center'}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}
